/**
 * tiers.js — the three Mixtape Memories products, for display.
 *
 * Figures come from tiers.json, which mirrors server/config/tiers.js (the server is
 * what actually charges; server/tests/tiers.test.js keeps the two in step). Import
 * prices from here rather than typing "$450" into a page, so a price change is one
 * edit plus that test.
 */
import data from './tiers.json';

export const TIERS = data.tiers;
export const DEFAULT_TIER_ID = 'make_your_own';
export const REFERRAL = data.referral;
export const SOONER = data.sooner;

/** The tier for an id. Unknown, missing or legacy values fall back to Make Your Own. */
export const getTier = (id) => TIERS.find((t) => t.id === id) || TIERS.find((t) => t.id === DEFAULT_TIER_ID);

/**
 * AUD cents → "$450" for whole dollars, "$899.10" otherwise. No "AU" prefix: the
 * surrounding copy says the prices are Australian dollars where that matters.
 */
export const formatPrice = (cents) => {
  const dollars = cents / 100;
  return Number.isInteger(dollars)
    ? `$${dollars.toLocaleString('en-AU')}`
    : `$${dollars.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

/** What a referred family pays for a tier (10% off, rounded to the cent like the server). */
export const referredPriceCents = (id) => {
  const price = getTier(id).priceCents;
  return price - Math.round(price * (REFERRAL.discountPercent / 100));
};

/** The partner's referral reward for a family buying this tier. */
export const referralRewardCents = (id) =>
  Math.round(getTier(id).priceCents * (REFERRAL.rewardPercent / 100));

/** Partner wholesale discount off the matching family price, as a whole percent (44 / 54 / 52). */
export const partnerDiscountPercent = (id) => {
  const t = getTier(id);
  return Math.round((1 - t.partnerPriceCents / t.priceCents) * 100);
};
